import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {DraftNode} from 'common/src/components/CLCardsMap/CardsMapContainer/CardsMapContainer.types';
import {Placement_UI} from 'common/src/modules/campaignPlacements/placements.types';
import {DTVersion} from 'common/src/modules/decisionTree/decisionTree.types';
import {DTControlMode} from 'common/src/modules/decisionTree/treeTypes';
import {DisableCampaignChangesReason, FCCampaign} from '../../campaigns.types';
import {campaignTreeInitialState} from './campaignTree.config';

const campaignTree = createSlice({
  name: 'campaignTree',
  initialState: campaignTreeInitialState,
  reducers: {
    resetCampaignTreeState: () => campaignTreeInitialState,
    updateCampaignPlacements: (state, action: PayloadAction<Placement_UI[]>) => {
      state.campaignPlacements = action.payload;
    },
    updateVersionNumber: (state, action: PayloadAction<number>) => {
      state.versionNumber = action.payload;
    },
    updateVersionId: (state, action: PayloadAction<number>) => {
      state.versionId = action.payload;
    },
    updateControlMode: (state, action: PayloadAction<DTControlMode>) => {
      state.controlMode = action.payload;
    },
    updateCampaignVersions: (state, action: PayloadAction<DTVersion[]>) => {
      state.campaignVersions = action.payload;
    },
    addDisableReason: (state, action: PayloadAction<DisableCampaignChangesReason>) => {
      state.disableCampaignChangesReasons.push(action.payload);
    },
    removeDisableReason: (state, action: PayloadAction<DisableCampaignChangesReason>) => {
      state.disableCampaignChangesReasons = state.disableCampaignChangesReasons.filter(
        (reason) => reason !== action.payload,
      );
    },
    updateIsCampaignChangedByCollaborator: (state, action: PayloadAction<boolean>) => {
      state.isCampaignChangedByCollaborator = action.payload;
    },
    updateTearsheetName: (state, action: PayloadAction<string>) => {
      state.tearsheetName = action.payload;
    },
    updateScheduledStatus: (state, action: PayloadAction<boolean>) => {
      state.isScheduled = action.payload;
    },
    updateIsCampaignOutputMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.isCampaignOutputMenuOpen = action.payload;
    },
    updateIsCampaignLoading: (state, action: PayloadAction<boolean>) => {
      state.isCampaignLoading = action.payload;
    },
    updateDraftNode: (state, action: PayloadAction<DraftNode>) => {
      state.draftNode = action.payload;
    },
    updateCampaign: (state, action: PayloadAction<FCCampaign>) => {
      state.campaign = action.payload;
    },
    updateConceptCampaign: (state, action: PayloadAction<FCCampaign>) => {
      state.conceptCampaign = action.payload;
    },
  },
});

export const {
  resetCampaignTreeState,
  updateCampaignPlacements,
  updateVersionNumber,
  updateVersionId,
  updateControlMode,
  updateCampaignVersions,
  addDisableReason,
  removeDisableReason,
  updateIsCampaignChangedByCollaborator,
  updateTearsheetName,
  updateScheduledStatus,
  updateIsCampaignOutputMenuOpen,
  updateIsCampaignLoading,
  updateDraftNode,
  updateCampaign,
  updateConceptCampaign,
} = campaignTree.actions;

export default campaignTree.reducer;
